// extracted by mini-css-extract-plugin
module.exports = {"container":"ReactionsCount_container__CQcuB","hidden":"ReactionsCount_hidden__F3I8Z","total":"ReactionsCount_total__FNTYa"};